import React from 'react';
import Breadcrumbs from '../../elements/Breadcrumbs';
import { CardsContainer } from './TypeOfService.style';
import SimpleCard from '../../elements/SimpleCard';
import { Skeleton } from '@material-ui/lab';
import NotFoundService from './NotFoundService';
import AppointmentInfoTab from '../AppointmentInfoTab/AppointmentInfoTab';

const TypeOfServece = ({
    isLoading,
    servicesList,
    handleClickCard,
    isReferral,
}) => {

    if(!isLoading && servicesList.length === 0) {
        return (
            <NotFoundService />
        )
    }

    return (
        <>
        {isReferral ?
            <AppointmentInfoTab text={`Прием пациентов по направлению осуществляется ТОЛЬКО при наличии направления ф.057/у-04`}/>
            : <></>
        }
            <Breadcrumbs pathArr={[{ label: 'Запись на прием' }, { label: 'Услуги' }]} />
            <CardsContainer>
                {isLoading
                    ? <>
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                        <Skeleton variant="rect" height={60} style={{ margin: '8px' }} />
                    </>
                    :
                    servicesList.map((item) =>
                        <div
                            onClick={() => handleClickCard(item.categoryType, item.name)}
                            key={item.id}
                        >
                            <SimpleCard label={item.name} />
                        </div>
                    )
                }
            </CardsContainer>
        </>
    )
}

export default TypeOfServece;
